module.exports = __webpack_public_path__ + "static/media/powered_by_suntec.3e4bd70b.png";